import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL?.trim().replace(/\/$/, "");
export const API = BACKEND_URL ? `${BACKEND_URL}/api` : "/api";

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const authHeader = (): Record<string, string> => {
  const token = localStorage.getItem("edx_admin_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const EDX = {
  name: "EDENOX",
  full: "EDENOX (PTY) LTD",
  reg: "2025/449442/07",
  founder: "Thembinkosi Eden Thwala",
  founderShort: "Eden Thwala",
  email: "thwalathembinkosi16@gmail.com",
  location: "68 9th Avenue, Mid-Ennerdale, Johannesburg, Gauteng, 1830",
  city: "Johannesburg, South Africa",
  logo: "/edenox-logo.png",
  portrait: "/eden-thwala.jpg",
  slogan: "Innovation, Fortified!",
  whatsapp: "27693974968",
  emails: {
    info: "info@edenox.co.za",
    contact: "contact@edenox.co.za",
    billing: "billing@edenox.co.za",
    founder: "thwalathembinkosi16@gmail.com",
  },
  socials: {
    instagram: "https://instagram.com/edenox",  // update with real handle
    facebook: "https://facebook.com/edenox",
    tiktok: "https://tiktok.com/@edenox",
    whatsapp: "https://wa.me/27693974968",
    linkedin: "https://linkedin.com/company/edenox",
  },
};
